import React, { useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createQueryClient } from './queryClient';

type Props = { children: React.ReactNode };

/**
 * TanStack Query boundary: all server / async Strapi data should use hooks below this.
 */
export function QueryProvider({ children }: Props) {
  const [client] = useState(() => createQueryClient());

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
